import { serializeQueryParams } from 'utils';

import { dnevnikApi } from './impl';

export const getParallelCurricula = (personId: string) =>
  dnevnikApi.get(`/parallel_curricula${serializeQueryParams({ person_id: personId })}`);
